import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PhoneFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 22, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 22) / 22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.388 16.3342L18.4169 13.363C17.3557 12.3019 15.5518 12.7264 15.1273 14.1058C14.809 15.0608 13.7479 15.5914 12.7929 15.3791C10.6706 14.8486 7.80553 12.0896 7.27496 9.86125C6.95662 8.90619 7.5933 7.84506 8.54832 7.52676C9.92779 7.10231 10.3522 5.29838 9.29111 4.23725L6.31994 1.26608C5.47103 0.523286 4.19768 0.523286 3.45488 1.26608L1.43873 3.28223C-0.577423 5.4045 1.65096 11.0285 6.63828 16.0158C11.6256 21.0031 17.2496 23.3377 19.3719 21.2154L21.388 19.1992C22.1309 18.3503 22.1309 17.077 21.388 16.3342Z"
        fill="currentColor"
      />
    </svg>
  )
})

PhoneFilled.displayName = 'PhoneFilled'
